import { Box, Button, Typography } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import PIS, { API_URL } from "../../../api/api";
import AddAlertMessage from "../../../components/alert/Alert";
import CustomModal from "../../../components/modal/CustomModal";
import { AFTER_DELETE_YOU_CAN_NOT_UNDONE_MSG, ERROR, SOMETHING_WENT_WRONG, SUCCESS } from "../../../utils/constants";
import AddCategoryModal from "./helpers/AddCategoryModal";
import CategoryList from "./helpers/CategoryList";
import styles from "./style";

export default function Category() {
  const classes = styles();
  const [openAddCategoryModal, setOpenAddCategoryModal] = useState(false);
  const [modalDefaultValues, setModalDefaultValues] = useState({});
  const [categoryTableData, setCategoryTableData] = useState([]);
  const [showDeleteCategoryModal, setShowDeleteCategoryModal] = useState(false);
  const [tableRowId, setTableRowId] = useState(null);

  useEffect(() => {
    getCategoryData();
  }, []);

  const handleAddCategoryModalClose = () => {
    setModalDefaultValues({});
    setOpenAddCategoryModal(false);
  }

  const handleCustomModelClose = () => {
    setShowDeleteCategoryModal(false)
    setTableRowId(null)
  }

  const getCategoryData = () => {
    PIS.get(API_URL.category)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setCategoryTableData(jsondata.data || []);
          setOpenAddCategoryModal(false);
        }
        else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const handleAddCategoryModalSubmit = data => {
    data.id = modalDefaultValues.id;
    PIS.post(API_URL.category, data)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          handleAddCategoryModalClose();
          getCategoryData();
        }
        else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const handleEditCategory = id => {
    PIS.get(API_URL.category + "/" + id).then(response => {
      let jsondata = response.data;
      if (jsondata.type === SUCCESS) {
        setModalDefaultValues(jsondata.data);
        setOpenAddCategoryModal(true);
      }
      else {
        AddAlertMessage({ type: jsondata.type, message: jsondata.message });
      }
    }).catch(error => {
      AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
    });
  }

  const handleDepartmentDelete = (id) => {
    setShowDeleteCategoryModal(true);
    setTableRowId(id);
  }

  const deleteTableRow = () => {
    PIS.delete(API_URL.category + "/" + tableRowId).then(response => {
      let jsondata = response.data;
      if (jsondata.type === SUCCESS) {
        getCategoryData();
        setShowDeleteCategoryModal(false);
      }
      else {
        AddAlertMessage({ type: jsondata.type, message: jsondata.message });
      }
    }).catch(error => {
      AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
    });
  }

  return (
    <>
      <Box className={classes.root}>
        <Box className={classes.subCategoryHeading}>
          <Typography variant="h6">श्रेणी/तहहरु</Typography>
          <Box display="flex" alignItems="center">
            <Button variant="contained" color="primary" startIcon={<Add />} onClick={() => { setOpenAddCategoryModal(true) }}>नयाँ श्रेणी/तह थप्नुहोस्</Button>
          </Box>
        </Box>
        <Box textAlign="center">
          <CustomModal
            title="श्रेणी/तह हटाउनुहोस्।"
            onModalSubmit={deleteTableRow}
            showModal={showDeleteCategoryModal}
            onModalClose={handleCustomModelClose}
            submitButtonText="हटाउनुहोस्"
          >
            <Typography>के तपाइँ निश्चित हुनुहुन्छ कि तपाइँ यस विभागलाई हटाउन चाहनुहुन्छ?</Typography>
            <Typography color="error" variant="caption" component="em">* {AFTER_DELETE_YOU_CAN_NOT_UNDONE_MSG}</Typography>
          </CustomModal>
        </Box>
        <Box>
          <CategoryList tableData={categoryTableData} onEditRow={handleEditCategory} onDeleteRow={handleDepartmentDelete} showActionColumn={Boolean(categoryTableData?.length)} />
        </Box>
        <AddCategoryModal handleModalSubmit={handleAddCategoryModalSubmit} showAddCategoryModal={openAddCategoryModal} handleAddCategoryModalClose={handleAddCategoryModalClose} defaultValues={modalDefaultValues} />
      </Box>
    </>
  );
}